<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="rank-reward-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>

                    <div class="rank-wrapper">
                        <vuescroll>
                        <div class="rank-view">                       
                            <div class="rank-pannel">
                                <table>
                                    <tbody>
                                        <tr v-for="(item,index) in rankData" :key="index">
                                            <th class="rank-name">{{ item.name }}</th>
                                            <th>
                                                <div class="reward-list">
                                                    <div class="r-item" v-for="(r,k) in item.reward" :key="k">
                                                        <div class="pic">
                                                            <div class="icon"><img :src="require('@/assets/images/'+ r +'.jpg')" alt="" srcset=""></div>
                                                        </div>
                                                        <p class="itemname">{{ item.itemname[k] }}</p>
                                                    </div>
                                                </div>
                                            </th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        </vuescroll>
                    </div>

                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style scoped>
.rank-reward-modal{
    position: relative;
    width: 578px;
    height: 642px;
    font-size: 24px;
    color: #6f3615;
    font-family: '楷体';
    /* background-image: url(~@/assets/images/bg-rank-reward.png); */
    background-image: url(~@/assets/images/bg-rule.png);
}

.title{
    width: 195px;
    height: 28px;
    margin: 15px auto 24px;
    background-image: url(~@/assets/images/title-rank.png);    
}

.rank-wrapper{
    height: 500px;
    padding: 0 10px;
}

.rank-pannel{
    width: 548px;
    height: 1031px;
    margin: 0 auto;
    background-image: url(~@/assets/images/bg-rank-table.png);   
}
.reward-list{
    display: flex;
    width: 400px;
    padding-top: 12px;
    justify-content: space-evenly;
}

.rank-name{
    width: 139px;
    height: 168px;
    color: #e66028;
}

.itemname{
    width: 105px;
    margin: 0 auto;
    font-size: 20px;
    color: #713725;
}

</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            rankData : [{
                name : '第1名',
                reward: ['C001','C002','C003'],
                itemname : ['10000绑定梦三币','动态称号*天鸡不可泄露（90天）','虎牙直播鸡王奖励包']
            },{
                name : '第2名',
                reward: ['C001','C002','C003'],
                itemname : ['8000绑定梦三币','动态称号*天鸡不可泄露（90天）','虎牙直播亚军奖励包']                
            },{
                name : '第3名',
                reward: ['C001','C002','C003'],
                itemname : ['5000绑定梦三币','动态称号*天鸡不可泄露（90天）','虎牙直播季军奖励包']                      
            },{
                name : '第4-10名',
                reward: ['C001','C004','C003'],
                itemname : ['3000绑定梦三币','勋章*威震华夏（30天）','虎牙直播优胜奖励包']                      
            },{
                name : '第11-50名',
                reward: ['C001','C004'],
                itemname : ['2000绑定梦三币','勋章*威震华夏（30天）']                  
            },{
                name : '第51-160名',
                reward: ['C001','C004'],
                itemname : ['1000绑定梦三币','勋章*威震华夏（30天）']                  
            }],              
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        //this.$be_busy();
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>


// WEBPACK FOOTER //
// src/components/RankRewardModal/rankRewardModal.vue